import { render, staticRenderFns } from "./UserTrackings.vue?vue&type=template&id=475cb352&"
import script from "./UserTrackings.vue?vue&type=script&lang=js&"
export * from "./UserTrackings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports